import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

// Define the context type
export type SpotlightContextType = {
  focus: (element: HTMLElement, options?: { padding?: number; content: ReactNode }) => void;
  dismiss: () => void;
};

// Create the context with a default value
export const SpotlightContext = createContext<SpotlightContextType>({
  focus: () => {},
  dismiss: () => {},
});

// Hook to use the spotlight context
export const useSpotlight = () => useContext(SpotlightContext);
